import { ObjectIteratee, findKey, isNil, pickBy } from 'lodash';

export function pickDefined<T extends object>(object: T) {
    return pickBy(object, (v) => !isNil(v));
}

export function pickTruthy<T extends object>(object: T) {
    return pickBy(object, (v) => v);
}

export function findTypedKey<T extends object>(
    object: T | null | undefined,
    predicate?: ObjectIteratee<T>
): keyof T | undefined {
    return findKey(object, predicate) as keyof T;
}
